import React, { FC } from 'react'
import { InputComponent } from 'LibNeo'
import {
	InterfaceElementModel,
	interfaceElementSlice,
	interfaceElementsSelector,
} from 'Pages/interfaceElement'
import { useSelector } from 'react-redux'
import { FieldNames } from 'Constants/FieldNames'
import { useAppDispatch } from 'Src/hooks'

interface ComponentProps {
	item: InterfaceElementModel
	field: FieldNames
}

const actions = {
	setDataItem: interfaceElementSlice.actions.setDataItem,
}

export const CustomColumnInput: FC<ComponentProps> = ({ item, field }) => {
	const { setDataItem } = useAppDispatch(actions)
	const editId = useSelector(interfaceElementsSelector.getEditId)
	const dataItem = useSelector(interfaceElementsSelector.getDataItem)
	const changeEditedRowData = (field: string) => (value) => {
		setDataItem({ ...dataItem, [field]: value })
	}
	if (editId === item.id) {
		return (
			<InputComponent
				value={field in dataItem ? dataItem?.[field] : item?.[field]}
				onChange={changeEditedRowData(field)}
				allowClear
			/>
		)
	}
	return <div>{item?.[field]}</div>
}
